import React, {createContext, Dispatch, SetStateAction, useContext, useState} from 'react';
import {IOfferItem} from '../../types/offers';

interface IOffersContext {
  offersList: IOfferItem[];
  setOffersList: Dispatch<SetStateAction<IOfferItem[]>>;
  canFetchList: boolean;
  setCanFetchList: Dispatch<boolean>;
}

const OffersContext = createContext<IOffersContext>({
  offersList: [],
  setOffersList: () => {},
  canFetchList: true,
  setCanFetchList: () => {}
});

export const OffersContextProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [offersList, setOffersList] = useState<IOfferItem[]>([]);
  const [canFetchList, setCanFetchList] = useState<boolean>(true);
  return (
    <OffersContext.Provider value={{offersList, setOffersList, canFetchList, setCanFetchList}}>
      {children}
    </OffersContext.Provider>
  );
};

export const useOffersContext = () => {
  const context = useContext(OffersContext);

  if (!context) {
    throw new Error('useUserContext must be used within useContextProvider');
  }

  return context;
};
